import React from 'react';

export const defaultAppContext = {

};

export const AppContext = React.createContext(defaultAppContext);
